<template>
  <header class="header">
    <div class="holder">
      <div class="left">
        <h1 class="logo">
          <router-link :to="{name: 'b000'}">
            <img src="../../assets/logo.png" alt="logo" />
          </router-link>
        </h1>
        <div class="name">
          <a href="#">{{ $t('common.admin_header_title')}}</a>
        </div>
      </div>
      <div class="right">
        <a href="#" @click="onLogout" class="button">{{ $t('common.admin_header_logout')}}</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    onLogout() {
      this.$store.dispatch("userStore/callActionLogout").then(() => {
        this.$router.push({ name: "b005" });
      });
    }
  }
};
</script>

<style  scoped>
</style>